"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapBattery = wrapBattery;
exports.filterAnswers = filterAnswers;
exports.screeners = void 0;

var _unzip2 = _interopRequireDefault(require("lodash/unzip"));

var _zip2 = _interopRequireDefault(require("lodash/zip"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var screeners = {
  ORS: "ORS",
  PSS_DEPRECATED: "PSS_DEPRECATED",
  PSS4: "PSS4",
  PSS4RTW: "PSS4RTW",
  STRESS: "STRESS",
  STRESS_STUDENTS: "STRESS_STUDENTS",
  PERSONALISATION: "PERSONALISATION",
  PSS10: "PSS10",
  PSYCAP: "PSYCAP",
  ROI_HPQ_3: "ROI_HPQ_3",
  ROI_HPQ_3_DAYSLIDE: "ROI_HPQ_3_DAYSLIDE",
  ROI_HPQ_3_POINTSLIDE: "ROI_HPQ_3_POINTSLIDE",
  ROI_HPQ_4_DAYSLIDE: "ROI_HPQ_4_DAYSLIDE",
  WHO5: "WHO5",
  WHO5RTW: "WHO5RTW",
  WHO5RTWUS: "WHO5RTWUS",
  workplaceQuestionnaire5: "workplaceQuestionnaire5",
  PHQ9: "PHQ9",
  GAD7: "GAD7",
  WRKBTY: "WRKBTY",
  SICK: "SICK",
  HRQOL: "HRQOL",
  ECOVAL: "ECOVAL",
  ECOVALUS: "ECOVALUS",
  RTWDEMOG: "RTWDEMOG",
  CSQ8: "CSQ8",
  HELPFUL: "HELPFUL",
  RTW_PRE_SCREENER: "RTW_PRE_SCREENER",
  RTW_FEEDBACK: "RTW_FEEDBACK",
  PROGRESS: "PROGRESS",
  RTW_US_ONBOARDING: "RTW_US_ONBOARDING",
  RTW_US_FEEDBACK: "RTW_US_FEEDBACK",
  MEDIBANK_WHO5: "MEDIBANK_WHO5",
  MEDIBANK_STRESS: "MEDIBANK_STRESS",
  MEDIBANK_PERSONALISATION: "MEDIBANK_PERSONALISATION",
  ALLIANZ_WHO5: "ALLIANZ_WHO5",
  ALLIANZ_STRESS: "ALLIANZ_STRESS",
  ALLIANZ_PERSONALISATION: "ALLIANZ_PERSONALISATION",
  ALLIANZ_PROGRESS: "ALLIANZ_PROGRESS",
  MEDIBANK_PROGRESS: "MEDIBANK_PROGRESS",
  MEDIBANK_PROGRESS_V1: "MEDIBANK_PROGRESS_V1",
  MEDIBANK_STRESS_ONBOARDING: "MEDIBANK_STRESS_ONBOARDING",
  MEDIBANK_STRESS_V1: "MEDIBANK_STRESS_V1",
  MEDIBANK_STRESS_V2: "MEDIBANK_STRESS_V2"
};
/**
  Creates question list filling in blanks with base props
  @param {Array} [questions] the questions to wrap and add additional properties too if they don't exitst
  @param {Object} [props] the base props for each question
  @return {Array} of wrapped questions
**/

exports.screeners = screeners;

function wrapBattery(questions, props) {
  return questions.map(function (q) {
    return Object.assign({}, props, q);
  });
}
/**
  Returns array of answers for a given batteryId
  @param {Array} [questions] users questions
  @param {Array} [answers] users answers
  @param {String} [batteryId] batteryId to get answers for
  @return {Array} users answers for the questions of that battery
**/


function filterAnswers(questions, answers, batteryId) {
  var filtered = (0, _zip2["default"])(questions, answers).filter(function (qa) {
    return qa[0] && qa[0].batteryId === batteryId;
  });
  return (0, _unzip2["default"])(filtered)[1];
}